import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const Breadcrumb = ({ activeSection }) => {
  const navigate = useNavigate();

  const sectionLabels = {
    'profile': 'Profile Information',
    'security': 'Security Settings',
    'notifications': 'Notification Preferences',
    'app-config': 'App Configuration',
    'privacy': 'Privacy & Data'
  };

  const breadcrumbItems = [
    { label: 'Dashboard', path: '/dashboard' },
    { label: 'Account Settings', path: '/account-settings' },
    { label: sectionLabels[activeSection] || 'Settings', path: null }
  ];

  const handleNavigation = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <div className="flex items-center space-x-2 text-sm text-muted-foreground mb-6">
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon name="ChevronRight" size={14} className="text-muted-foreground" />
          )}
          {item.path ? (
            <button
              onClick={() => handleNavigation(item.path)}
              className="hover:text-foreground transition-colors duration-200 focus:outline-none focus:text-foreground"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-foreground font-medium">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;